import { useEffect } from 'react'
import './YouTubeModal.css'

const YouTubeModal = ({ videoUrl, isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  // Extract YouTube video ID from various URL formats
  const getYouTubeId = (url) => {
    if (!url) return null
    
    // Handle different YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/.*[?&]v=([^&\n?#]+)/,
    ]
    
    for (const pattern of patterns) {
      const match = url.match(pattern)
      if (match && match[1]) {
        return match[1]
      }
    }
    
    return null
  }

  const videoId = getYouTubeId(videoUrl)
  
  if (!videoId) {
    // If not a YouTube URL, try to open in new tab
    return (
      <div className="youtube-modal-overlay" onClick={onClose}>
        <div className="youtube-modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="youtube-modal-close" onClick={onClose}>
            ×
          </button>
          <div className="youtube-modal-error">
            <p>جارٍ فتح الفيديو في نافذة جديدة...</p>
            <a href={videoUrl} target="_blank" rel="noopener noreferrer">
              افتح الفيديو
            </a>
          </div>
        </div>
      </div>
    )
  }

  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`

  return (
    <div className="youtube-modal-overlay" onClick={onClose}>
      <div className="youtube-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="youtube-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="youtube-modal-video">
          <iframe
            src={embedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            title="YouTube video player"
          />
        </div>
      </div>
    </div>
  )
}

export default YouTubeModal

